import React, { Component } from 'react';

import api from 'api';
import { Text, Tooltip, Box } from 'components';
import { numberFormatter, dateFormatter, currencyFormatter } from 'helpers';

class Contributions extends Component {
  state = {
    contributions: null,
  };

  componentDidMount() {
    api.get('contributions').then(res => {
      this.setState({ contributions: res.data.items });
    });
  }

  render() {
    const { contributions } = this.state;

    if (!contributions) return null;

    return (
      <Box>
        <Box flex>
          <Box mr="auto">
            <Text display="h1">Contribution Details</Text>
            <Text>
              Initial contributions during the private sale will be displayed
              here.
            </Text>
          </Box>
        </Box>
        <Box flex className="table-header">
          <Box flex="1">
            Date{' '}
            <Tooltip
              placement="top"
              text="The date that your contribution was sent."
            />
          </Box>
          <Box flex="1">
            Currency{' '}
            <Tooltip
              placement="top"
              text="The currency that was used for your contribution."
            />
          </Box>
          <Box flex="1">
            USD Equivalent{' '}
            <Tooltip
              placement="top"
              text="The equivalent value of your tokensale contribution in USD."
            />
          </Box>
          <Box flex="1">
            Principal CRNC{' '}
            <Tooltip
              placement="top"
              text="The tokens that will be issued on the day of token issuance."
            />
          </Box>
          <Box flex="1">
            Total Bonus CRNC{' '}
            <Tooltip
              placement="top"
              text="The total number of bonus tokens to be distributed, as per your agreement."
            />
          </Box>
          <Box flex="1">
            Bonus Vesting Period (mo){' '}
            <Tooltip
              placement="top"
              text="The duration, in months, over which your bonus tokens will be sent. Payments will be made monthly"
            />
          </Box>
        </Box>
        {contributions.length > 0 &&
          contributions.map(contribution => {
            return (
              <Box key={contribution.id} flex className="table-body">
                <Box data-title="Date" flex="1">
                  {dateFormatter(contribution.contributed_at)}
                </Box>
                <Box data-title="Currency" flex="1">
                  {contribution.currency_used}
                </Box>
                <Box data-title="USD" flex="1">
                  {currencyFormatter(contribution.contribution_usd_equivalent)}
                </Box>
                <Box data-title="Principal CRNC" flex="1">
                  {numberFormatter(contribution.principal_tokens)}
                </Box>
                <Box data-title="Total Bonus CRNC" flex="1">
                  {numberFormatter(contribution.bonus_tokens)}
                </Box>
                <Box data-title="Bonus Vesting Period (mo)" flex="1">
                  {contribution.bonus_vesting_period}
                </Box>
              </Box>
            );
          })}
      </Box>
    );
  }
}

export default Contributions;
